<template>
  <div
    class="tw-flex tw-flex-col tw-gap-16 tw-overflow-y-auto scrollbar-hide tw-px-4 tablet:tw-px-20 tw-min-w-[300px]"
  >
    <!-- Privacy Policy -->
    <div class="tw-flex tw-flex-col tw-gap-8 tw-pb-[112px] tw-border-b dark:tw-border-ap-dim-grey tw-border-ap-gainsboro">
      <h1 class="tw-text-h2-bold-mobile apDesktop:tw-text-h2-bold-desktop">
        {{ $t('privacy_policy') }}
      </h1>
      <p
        class="tw-text-body-mobile apDesktop:tw-text-body-desktop tw-text-ap-nobel dark"
        v-html="$t('privacy_policy_desc')"
      />
    </div>
    <!-- What We Collect and Why -->
    <div class="tw-flex tw-flex-col">
      <!-- Header -->
      <h2 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop tw-pb-8">
        {{ $t('what_we_collect_and_why') }}
      </h2>
      <!-- Content Gap80px -->
      <div class="tw-flex tw-flex-col tw-gap-20">
        <!-- Personal Infromation -->
        <div class="tw-flex tw-flex-col tw-gap-5">
          <p class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop" v-html="$t('personal_information')" />
          <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('personal_information_desc')" />
        </div>
        <!-- Logs -->
        <div class="tw-flex tw-flex-col tw-gap-5">
          <p class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop" v-html="$t('logs')" />
          <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('logs_desc')" />
        </div>
        <!-- Information about children -->
        <div class="tw-flex tw-flex-col tw-gap-5">
          <p
            class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop"
            v-html="$t('information_about_children')"
          />
          <p
            class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
            v-html="$t('information_about_children_desc', {
              email: '<a href=\'mailto:hello+privacy@the-next.co\'>hello+privacy@the-next.co</a>'
            })"
          />
        </div>
        <!-- Header: How We Use Your Information -->
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop tw-pb-8">
            {{ $t('how_we_use_your_information') }}
          </h2>
          <div class="tw-flex tw-flex-col tw-gap-20">
            <!-- Personal Infromation -->
            <div class="tw-flex tw-flex-col tw-gap-5">
              <p
                class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop"
                v-html="$t('personal_information')"
              />
              <p
                class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
                v-html="$t('personal_information_desc_2')"
              />
            </div>
            <!-- Use of navigational information -->
            <div class="tw-flex tw-flex-col tw-gap-5">
              <p
                class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop"
                v-html="$t('use_of_navigational_information')"
              />
              <p
                class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
                v-html="$t('use_of_navigational_information_desc')"
              />
            </div>
            <!-- External websites -->
            <div class="tw-flex tw-flex-col tw-gap-5">
              <p class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop" v-html="$t('external_websites')" />
              <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('external_websites_desc')" />
            </div>
            <!-- Retention of personal information -->
            <div class="tw-flex tw-flex-col tw-gap-5">
              <p
                class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop"
                v-html="$t('retention_of_personal_information')"
              />
              <p
                class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
                v-html="$t('retention_of_personal_information_desc')"
              />
            </div>
          </div>
        </div>

        <!-- Header: How We Share Your Information -->
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop tw-pb-8">
            {{ $t('how_we_share_your_information') }}
          </h2>
          <div class="tw-flex tw-flex-col tw-gap-20">
            <!-- Service Providers -->
            <div class="tw-flex tw-flex-col tw-gap-5">
              <p class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop" v-html="$t('service_providers')" />
              <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('service_providers_desc')" />
            </div>
            <!-- Corporate Events -->
            <div class="tw-flex tw-flex-col tw-gap-5">
              <p class="tw-text-body-bold-mobile apDesktop:tw-text-body-bold-desktop" v-html="$t('corporate_events')" />
              <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('corporate_events_desc')" />
            </div>
          </div>
        </div>

        <!-- Header: The Use of Cookies -->
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop tw-pb-8">
            {{ $t('the_use_of_cookies') }}
          </h2>
          <!-- Description -->
          <p class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="$t('the_use_of_cookies_desc')" />
        </div>

        <!-- Header: The Use of Cookies Disc -->
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop tw-pb-8">
            {{ $t('the_use_of_cookies') }}
          </h2>
          <!-- Points -->
          <p
            class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
            v-html="$t('the_use_of_cookies_disc', {
              email: '<a href=\'mailto:hello+privacy@the-next.co\'>hello+privacy@the-next.co</a>'
            })"
          />
        </div>

        <!-- Header: Data Protection Officer -->
        <div class="tw-flex tw-flex-col tw-pb-20">
          <h2 class="tw-text-h4-bold-mobile apDesktop:tw-text-h4-bold-desktop tw-pb-8">
            {{ $t('data_protection_officer') }}
          </h2>
          <!-- Points -->
          <p
            class="tw-text-body-mobile apDesktop:tw-text-body-desktop"
            v-html="$t('data_protection_officer_desc', {
              email: '<a href=\'mailto:hello+privacy@the-next.co\'>hello+privacy@the-next.co</a>'
            })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

const emit = defineEmits(['showCookiePolicy']);

onMounted(() => {
  onLoad();
  window.addEventListener('load', onLoad);
});

function onLoad() {
  const cookiePolicy = document.getElementById('cookie-policy-link');
  if (cookiePolicy) {
    cookiePolicy.style.cursor = 'pointer';
    cookiePolicy?.addEventListener('click', () => {
      emit('showCookiePolicy');
    });
  }
}

</script>

<style scoped></style>